import { useEffect, useState } from "react"
import { useEntidad, useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { SectionHeading, TableCustom } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { getDateToString, getFormatNumber } from "../../utils/convert"
import DevolucionesGridModal from "../../components/controls/DevolucionesGridModal"

const initItem = {
    id: 0,
    importeTotal: 0
}

const DevolucionConciliacionView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [lotes, setLotes] = useState([])
    const [editItem, setEditItem] = useState(initItem)
    const [showDetalle, setShowDetalle] = useState(false)

    const [, getRowEntidad ] = useEntidad({
        entidades: ['Recaudadora'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'Recaudadora',
          timeout: 0
        }
    })

    useEffect(() => SearchLotes(), [])

    const SearchLotes = () => {
        setIsLoading(true)

        const paramsUrl = `/conciliacion`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.DEVOLUCION_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                data.sort((a,b) => b.id - a.id)
                setLotes(data)
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.DEVOLUCION_LOTE,
            `/${id}`,
            null,
            () => {
                setLotes(prev => prev.filter(x => x.id !== id))
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const confirmReconciliacionId = (id) => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.DEVOLUCION_LOTE,
            `/reconciliacion/${id}`,
            null,
            () => {
                SearchLotes()
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        customActions: [
            {
                icon: 'refresh',
                title: 'Reconciliar devolución',
                onClick: ({ id }) => {
                    showMessageModal({
                        title: "Confirmación",
                        message: "¿Está seguro de reconciliar el lote?",
                        onConfirm: () => confirmReconciliacionId(id),
                    })
                },
                requiresEdit: true
            }
        ],
        customActionsPosition: 'before',
        onView: (item) => {
            setEditItem(item)
            setShowDetalle(true)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el lote?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    const onModalCancel = (refresh = false) => {
        setShowDetalle(false)
        setEditItem(initItem)
        if (refresh) SearchLotes()
    }

    return <>
        <SectionHeading titles={[{ title: 'Devoluciones' }, { title: 'Conciliación de devoluciones' }]} />

        <section className='section-accordion'>

            <TableCustom
                className={'TableCustomBase'}
                data={lotes}
                avmr={avmr}
                columns={[
                    { Header: 'Recaudadora', accessor: 'idRecaudadora', width: '20%', Cell: ({ value }) =>  getRowEntidad('Recaudadora', value)?.nombre ?? '' },
                    { Header: 'N° lote', accessor: 'numeroLote', width: '15%', },
                    { Header: 'Fecha lote', accessor: 'fechaLote', Cell: (data) => getDateToString(data.value), width: '12%' },
                    { Header: 'Fecha proceso', accessor: 'fechaProceso', Cell: (data) => getDateToString(data.value, true), width: '15%' },
                    { Header: 'Casos', accessor: 'casos', Cell: (data) => getFormatNumber(data.value, 0), width: '8%', alignCell: 'right' },
                    { Header: 'No conciliados', accessor: 'casosNoConciliados', Cell: (data) => getFormatNumber(data.value, 0), width: '8%', alignCell: 'right' },
                    { Header: 'Total', accessor: 'importeTotal', Cell: (data) => getFormatNumber(data.value, 2), width: '15%', alignCell: 'right' },
                ]}
            />

            {showDetalle && (
                <DevolucionesGridModal
                    lote={editItem}
                    onCancel={onModalCancel}
                />
            )}

        </section>
    </>
}

export default DevolucionConciliacionView
